module.exports = __webpack_public_path__ + "img/neutral-icon.63f6dd65.png";